// Import everything from signaling_pb.js
const signalingPb = require("./api/signaling/v1/signaling_pb.js");

// Import everything from signaling_grpc_web_pb.js
const signalingGrpcWebPb = require("./api/signaling/v1/signaling_grpc_web_pb.js");

// Combine all exports into a single object
const combinedExports = {
    ...signalingPb,
    ...signalingGrpcWebPb,
};

// Export the combined object as the default export
module.exports = combinedExports;
